import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getUsers } from "../repositories/userRepo";

const initialState = {
  data: [],
  loading: false,
  error: null,
};
export const getAdministratorsData = createAsyncThunk("administrators", async (thunkAPI) => {
  const response = await getUsers();
  return response;
});
const data = [

];
export const administratorsSlice = createSlice({
  name: "administrators",
  initialState,
  extraReducers: {
    [getAdministratorsData.pending]: (state) => {
      state.loading = true;
    },
    [getAdministratorsData.fulfilled]: (state, action) => {
      state.loading = false;
  
     action.payload.data.map(element => {
    // data.push(Object.values(element));
        data.push([element.id,element.username,element.email,element.phone])
      });
      state.data = data;
      //state.data= Object.values(action.payload.data);
    },
    [getAdministratorsData.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error.message;
      console.log(action.error);
    },
  },
  reducers: {},
});

export default administratorsSlice.reducer;
